export const DRIVER_LICENSE_ALLOWED_EXTENSIONS = [
  'pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tif', 'tiff', 'heic', 'heif',
];

export const DRIVER_LICENSE_FILENAME_FORMAT_REGEX = new RegExp(
  `^\\d+-[^-.]+-\\d{8}-.+\\.(${DRIVER_LICENSE_ALLOWED_EXTENSIONS.join('|')})$`,
  'i',
);

export class ValidateFileHelper {

  validateExtensions(event: any, allowedExtensions: string[]): boolean {
    const fileInput = event.target;

    if (fileInput.files && fileInput.files.length) {
      const filesArray: any = Array.from(fileInput.files);
      for (const file of filesArray) {
        const fileName = file.name.toLowerCase();

        // Check if the file extension is in the allowed list
        const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));

        if (!isValidExtension) {
          return false;
        }
      }
      return true;
    }

    return false;
  }

  validateFileExtension(fileName: string, allowedExtensions: string[]): boolean {
    const ext = (fileName.split('.').pop() || '').toLowerCase();
    return !!ext && allowedExtensions.includes(ext);
  }

  validateFileSize(fileSize: number, maxSizeInMB: number): boolean {
    return fileSize <= maxSizeInMB * 1024 * 1024;
  }

  validateMimeType(mimeType: string, allowedMimeTypes: string[]): boolean {
    return !mimeType || allowedMimeTypes.includes(mimeType);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/validate-file-helper.service.ts